import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import { Checkbox } from 'components/Controls';
import MultiLanguageTextField from 'components/MultiLanguageTextField';
import ChoicesEditor from './ChoicesEditor';
// Types
import RegistrationFieldTypes from 'types/RegistrationFieldTypes';
import RegistrationFieldBindings from 'types/RegistrationFieldBindings';
// Utilities
import { isRequired, noWhitespace } from 'utilities/validation';

type Props = {
  fields: any[];
  append: (value:any) => void;
  remove: (index:number) => void;
}

const TeamSelectorField:FC<Props> = ({ fields, append, remove }) => {
  const { t } = useTranslation();

  const { formState: { errors } } = useFormContext();

  const teamIndex = fields.findIndex((field:any) => field.binding === RegistrationFieldBindings.Team);
  const teamField = teamIndex !== -1 ? fields[teamIndex] : null;

  const handleToggle = () => {
    if (teamIndex === -1) {
      append({
        ref: uuidv4(),
        title: 'Team',
        type: RegistrationFieldTypes.SingleChoice,
        required: true,
        binding: RegistrationFieldBindings.Team,
        choices: [{ ref: uuidv4(), title: '' }],
      });
    } else {
      remove(teamIndex);
    }
  }

  return (
    <div className="mb-4">
      <Checkbox
        id="hasTeamSelector" name="hasTeamSelector"
        label={t('pages.quizForm.teamSelectorEnabledLabel')}
        checked={teamIndex !== -1}
        onChange={handleToggle}
        helperText={t('pages.quizForm.teamSelectorEnabledHint')}
      />
      {teamField ? (
        <div className="pl-4">
          <MultiLanguageTextField
            name={`registrationPage.fields.${teamIndex}.title`}
            rules={{ required: isRequired, validate: noWhitespace }}
            label={t('labels.title')}
            className="mb-4"
            required
            error={Boolean(errors.registrationPage?.fields?.[teamIndex]?.title)}
            errorText={errors.registrationPage?.fields?.[teamIndex]?.title?.message || ''}
            customKey={`registrationPage.fields.${teamField.ref}.title`}
          />
          <ChoicesEditor
            name={`registrationPage.fields.${teamIndex}.choices`}
            fieldRef={teamField.ref}
            itemLabel={t('labels.team')}
            minItems={1}
          />
        </div>
      ) : null}
    </div>
  )
}

export default TeamSelectorField;
